/* Hugobloom — scroll-reveal. Adds .visible to .reveal elements as they
   enter the viewport. Respects prefers-reduced-motion and degrades safely:
   if JS is off the inline head guard never adds html.hb-anim, so .reveal
   elements are never hidden. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el) { el.classList.add('visible'); }

  var observer = null;
  if (!reduce && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          show(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  }

  function arm(scope) {
    var nodes = (scope || document).querySelectorAll('.reveal:not(.visible)');
    for (var i = 0; i < nodes.length; i++) {
      if (observer) observer.observe(nodes[i]);
      else show(nodes[i]); // reduced motion or no IO support → reveal immediately
    }
  }

  function start() { arm(document); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  // Theme editor: re-arm reveals when a section is added/reloaded.
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
